export const label = 'Супроводжуючі документи (не обов’язково)';
export const maxLength = 200;
export const errors = {
  maxlength: `Максимальна довжина ${maxLength} символів`,
};
